import { Outlet } from "react-router-dom";
import { style } from "./style";

export default function PublicLayout() {
  return (
    <main style={style}>
      <Outlet />
    </main>
  );
}
